const env =
    process.env.REACT_APP_ENVIRONMENT ||
    process.env.NODE_ENV ||
    (process.env.REACT_APP_GO_LOCAL && 'development') ||
    'testing';

const production = env === 'testing' || env === 'development';

export const BUCKET = production ? 'statictemporalbc-staging' : 'statictemporalbc-production';

console.log({
    production,
    BUCKET,
})

export const BASE_CLIENT_URL = production ? 'https://bc-onboarding-test.dinclin.com' : 'https://sign.tarjetacolumbia.com.ar';
